

























import { mapGetters } from 'vuex';
import ButtonFull from 'theme/components/theme/ButtonFull.vue';

export default {
  name: 'PayOrderModalChangeMethods',
  components: {
    ButtonFull
  },
  props: {
    selectedMethod: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      payment: 'payment/paymentMethods'
    }),
    paymentMethods () {
      return this.payment.filter(method => ['card', 'ipay_masterpass', 'ipay_gpay', 'ipay_applepay'].includes(method.code))
    }
  }
}
